import { types, flow, getRoot } from "mobx-state-tree";
import { db, auth } from "../firebase.js";
import { actions } from "./_common.js";
import FirestoreDate from "./FirestoreDate";
import FirebaseStore from "./Firebase";
import * as dateFns from "date-fns";

const $firebase = new FirebaseStore();

const refSurveys = db.collection("surveys");

export const Respondent = types.compose(
  types
    .model({
      _key: types.maybeNull(types.string),
      _surveyKey: types.maybeNull(types.string),
      createdBy: types.maybeNull(types.string),
      groupKey: types.maybeNull(types.union(types.string, types.number)),
      answers: types.frozen([]),
      createdOn: types.maybeNull(FirestoreDate)
    })
    .actions(self => ({
      fsDelete: flow(function* () {
        getRoot(self).$alert.add("loading", {
          loader: "circle"
        });
        yield refSurveys.doc(self._surveyKey).collection("respondents").doc(self._key).delete();
        getRoot(self).$alert.delete("loading");
      })
    }))
    .views(self => ({
      get groupName() {
        return getRoot(self).$group.list.has(self.groupKey)
          ? getRoot(self).$group.list.get(self.groupKey).name
          : self.groupKey;
      },
      get userEmail() {
        return getRoot(self).$user.list.has(self.createdBy)
          ? getRoot(self).$user.list.get(self.createdBy).email +
              self.answers["ufxnATWEGy3EA4G47iIj"]
          : self.answers["ufxnATWEGy3EA4G47iIj"];
      }
    })),
  actions
);

export const RespondentStore = types.compose(
  types
    .model({
      list: types.optional(types.map(Respondent), {}),
      status: types.optional(types.string, "pending"),
      filterDateStart: types.optional(FirestoreDate, dateFns.subYears(new Date(), 5)),
      filterDateEnd: types.optional(FirestoreDate, dateFns.endOfDay(new Date()))
    })
    .actions(self => ({
      load: flow(function* load(surveyKey, groupKey = false, createdBy = false) {
        getRoot(self).$alert.add("loading");
        console.log("> load respondent:", surveyKey, groupKey, createdBy, self.filterDateStart);
        const snapshot = yield $firebase.getRespondents({
          surveyKey,
          groupKey,
          createdBy,
          dateStart: self.filterDateStart,
          dateEnd: self.filterDateEnd
        });

        self.clearList();

        snapshot.forEach(respondent => {
          self.setToList(respondent.id, {
            ...respondent.data(),
            _surveyKey: surveyKey
          });
        });
        self.change("status", "done");
        getRoot(self).$alert.delete("loading");
        return self.list.toJSON();
      })
    })),
  actions
);
